// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordResetForm_root__3XXxB","password":"PasswordResetForm_password__1cobC"};